var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cursor",style:({
          '--animation-duration': _vm.blinkSpeed+'s'
      })},[_vm._v(_vm._s(_vm._charBeneath))])
}
var staticRenderFns = []

export { render, staticRenderFns }